// Success / confirmation screen — RON-5466 Phase 2, reused throughout Phase 3.
//
// Deliberately generic: "Visitor invited", "Changes saved" and "Bookings cancelled" are all this
// component with different keys and, for the last, `variant="cancel"`.

import { useTranslation } from "react-i18next";

const VisitorConfirmation = ({
  titleKey,
  messageKey,
  // Substituted into `%s` in the message. The app interpolates with `.replace("%s", …)` rather
  // than i18next interpolation, so this follows that convention.
  messageValue,
  variant = "success",
  onBack,
}) => {
  const { t } = useTranslation("common");

  const message =
    messageValue === undefined
      ? t(messageKey)
      : t(messageKey).replace("%s", messageValue);

  return (
    <div className={`visitor-confirmation visitor-confirmation--${variant}`}>
      {/* A tick for every variant, including cancel. A cancellation that worked IS a success; the
          red tint on the disc already carries "that was destructive". An exclamation mark here read
          as though something had gone wrong. */}
      <span className="visitor-confirmation__mark" aria-hidden="true">
        ✓
      </span>
      <p className="visitor-confirmation__title">{t(titleKey)}</p>
      <p className="visitor-confirmation__message">{message}</p>
      <button
        type="button"
        className="visitor-btn visitor-btn--secondary"
        onClick={onBack}
      >
        {t("react_visitors_back_to_list")}
      </button>
    </div>
  );
};

export default VisitorConfirmation;
